module.exports = __webpack_public_path__ + "static/img/5.33e3b81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/5.jpg
// module id = KEJX
// module chunks = 1